import { APP_INITIALIZER, ApplicationConfig, importProvidersFrom, LOCALE_ID, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withRouterConfig } from '@angular/router';
import { TranslateLoader, TranslateModule, } from '@ngx-translate/core';
import { routes } from './app.routes';
import { HttpClient, provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { TranslationLoaderService } from './shared/services/translation/translation-loader.service';
import { HttpLoaderFactory } from './shared/functions/http-loader-factory';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideToastr } from 'ngx-toastr';
import { LoaderInterceptor } from './shared/interceptors/loader/loader.interceptor';
import { provideStore } from '@ngxs/store';
import { withNgxsReduxDevtoolsPlugin } from '@ngxs/devtools-plugin';
import { AuthState } from './shared/store/auth/auth.state';
import { withNgxsRouterPlugin } from '@ngxs/router-plugin';
import { LoaderState } from './shared/store/loader/loader.state';
import { ApiPrefixInterceptor } from './shared/interceptors/api-prefix/api-prefix.interceptor';
import { AuthInterceptor } from './shared/interceptors/auth/auth.interceptor';
import { withNgxsStoragePlugin } from "@ngxs/storage-plugin";
import { HttpErrorInterceptor } from './shared/interceptors/http-error/http-error.interceptor';
import { GuidHandlerInterceptor } from './shared/interceptors/api-responsefix/guid-handler.interceptor';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material/icon';
import { registerIcons } from './shared/functions/register-Icons-function';
import { ProviderState } from './shared/store/provider/provider.state';
import { PayerState } from './shared/store/payer/payer.state';
import { DateFormatInterceptor } from './shared/interceptors/api-responsefix/date-format.interceptor';
import { LanguageService } from './shared/services/translation/language.service';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { CustomHeadersInterceptor } from './shared/interceptors/custom-headers/custom-headers.interceptor';
import { PatientState } from './shared/store/patient/patient.state';
import { provideNgxMask } from 'ngx-mask';
import { MAT_DIALOG_DEFAULT_OPTIONS, MatDialogConfig } from '@angular/material/dialog';
import { provideServiceWorker } from '@angular/service-worker';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withRouterConfig({ onSameUrlNavigation: 'reload' })),
    provideStore(
      [AuthState, LoaderState, ProviderState, PayerState, PatientState],
      withNgxsStoragePlugin({ keys: '*' }),
      withNgxsRouterPlugin(),
      withNgxsReduxDevtoolsPlugin()
    ),
    provideHttpClient(
      withInterceptorsFromDi(),
      withInterceptors([LoaderInterceptor, HttpErrorInterceptor, CustomHeadersInterceptor, ApiPrefixInterceptor, AuthInterceptor, GuidHandlerInterceptor, DateFormatInterceptor])
    ),
    provideToastr({
      preventDuplicates: true,
      resetTimeoutOnDuplicate: true,
      countDuplicates: false,
      positionClass: 'toast-top-center'
    }),
    importProvidersFrom(
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient]
        }
      }),
    ),
    {
      provide: LOCALE_ID,
      deps: [LanguageService],
      useFactory: (languageService: LanguageService) => languageService.getLanguage(),
    },
    {
      provide: MAT_DATE_LOCALE,
      useValue: 'en'
    },
    {
      provide: MAT_DIALOG_DEFAULT_OPTIONS,
      useValue: {
        disableClose: true
      } as MatDialogConfig
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initTranslations,
      deps: [TranslationLoaderService],
      multi: true
    },
    MatIconRegistry,
    {
      provide: APP_INITIALIZER,
      useFactory: registerIcons,
      deps: [MatIconRegistry, DomSanitizer],
      multi: true,
    },
    provideNgxMask(),
    provideAnimationsAsync(),
    provideServiceWorker('ngsw-worker.js', {
      enabled: true,
      registrationStrategy: 'registerWhenStable:30000'
    }),
  ]
};

function initTranslations(translationLoader: TranslationLoaderService) {
  return () => translationLoader.loadTranslations();
}
